<div class="bloc_offers">

    <div class="bloc_offers_filters">

        <div>

            <div class="filters">

                <app-core-offer-filter
                    [mode]="mode"
                    [society]="society"
                    [roles]="roles"
                    [filterBuilder]="filterBuilder"
                    [prefixFilter]="prefixFilter"
                ></app-core-offer-filter>

                <div class="filter_item">
                    <button type="button" class="btn_cta btn_lines btn_small" (click)="!openFilterPanel ? openFilterPanel = true : openFilterPanel = false"><span class="ty-filter">{{ 'offer.list.filter.value' | translate }}</span></button>
                </div>

                <div class="col_12 y_items_center" *ngIf="hasOneOfThisMode(['hashtag-catalog', 'tender-personnal-offers']) || (isMode('channel') && integrationMode.value !== 'orchestra')">
                    <div class="form-group">
                        <span class="message-help">
                            <mat-icon  class="tooltip_icon">info</mat-icon>
                            {{'offer.filters.help.value' | translate}}
                        </span>
                    </div>
                </div>

                <div class="col_12 y_items_center" *ngIf="isMode('channel') && integrationMode.value === 'orchestra'">
                    <div class="form-group">
                        <span class="message-help">
                            <mat-icon  class="tooltip_icon">info</mat-icon>
                            {{'offer.filters.orchestra.help.value' | translate}}
                        </span>
                    </div>
                </div>

            </div>

            <div class="filters_checked">

                <ng-container *ngFor="let permanentDisplayedFilter of permanentDisplayedFilters;">

                    <span class="filter permanent_filter">
                        <span>{{ permanentDisplayedFilter.label }}</span>
                    </span>

                </ng-container>

                <ng-container *ngFor="let filter of getSessionsFilters(mode); trackBy: identifySessionFilter">

                    <ng-container *ngIf="isListFilter(filter.value) && filter.value.length > 0">
                        <span class="filter" (click)="removeFilter(filter.key, filter.value, val)" *ngFor="let val of getListFilter(filter)">
                            <span>{{ 'offer.filters.' + filter.key |  translate}}&nbsp;</span>
                            <span> {{ formatFilterValue(filter.key, val) }}</span>
                            <span class="close"><mat-icon>close</mat-icon></span>
                        </span>
                    </ng-container>

                    <ng-container *ngIf="!isListFilter(filter.value) && filter.value != null">
                        <span class="filter" (click)="removeFilter(filter.key, filter.value, null)">
                            <span>{{ 'offer.filters.' + filter.key |  translate}}&nbsp;</span>
                            <span> {{  formatFilterValue(filter.key, filter.value) }}</span>
                            <span class="close"><mat-icon>close</mat-icon></span>
                        </span>
                    </ng-container>
                </ng-container>
            </div>

        </div>

        <app-core-offer-filter-panel
            [hidden]="!openFilterPanel"
            [filterBuilder]="filterBuilder"
            [prefixFilter]="prefixFilter"
            [providerNetwork]="providerNetwork"
            [offerCreatorNetwork]="offerCreatorNetwork"
            [provider]="provider"
            [restrictedSocietyProviders]="restrictedSocietyProviders"
            [mode]="mode"
            [offerCreator]="offerCreator"
            [offerAttributeTouristsDestinations]="offerAttributeTouristsDestinations"
            [offerAttributeThemes]="offerAttributeThemes"
            [offerAttributeTypes]="offerAttributeTypes"
            [offerAttributeActivities]="offerAttributeActivities"
            [offerAttributeAccomodations]="offerAttributeAccomodations"
            [offerAttributeRestoration]="offerAttributeRestoration"
            [offerCustomerTypology]="offerCustomerTypology"
            (closeFilterPanelEvent)="closePanel($event)" [roles]="roles">
        </app-core-offer-filter-panel>

    </div>


    <div class="offers_list">
        <div class="list_links">
            <div class="row x_end">

                <!-- Hashtags -->

                <ng-container *ngIf="hashtags.length">

                    <div class="col_content">

                        <div class="hashtag_filter_item_container">

                            <span class="title">{{ 'sort.by.value' | translate }} :</span>

                            <div class="filter_item hashtag_filter_item">

                                <app-core-select-filter #hashtagFilter
                                    [builder]="filterBuilder"
                                    [label]="'offer.list.filter.hashtag.value' | translate"
                                    [key]="prefixFilter + 'hashtag'"
                                    [items]="hashtags"
                                    [itemLabelProperty]="'name'"
                                    [itemValueProperty]="'id'"
                                    [operator]="'eq'"
                                ></app-core-select-filter>

                            </div>

                        </div>

                    </div>

                </ng-container>

                <div class="col_content">

                    <!-- Prix Net / Public -->

                    <mat-radio-group *ngIf="hasOneOfThisRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_PROVIDER']) && isView('list') && hasOneOfThisMode(['catalog', 'channel', 'offer-permanent-option-catalog', 'hashtag-catalog', 'article-catalog'])" [(ngModel)]="publicPrice">
                        <mat-radio-button [value]="0">{{ 'offer.dateEngine.publicPrice.net.value' | translate }}</mat-radio-button>
                        <mat-radio-button [value]="1">{{ 'offer.dateEngine.publicPrice.public.value' | translate }}</mat-radio-button>
                    </mat-radio-group>

                    <span class="ty-map" *ngIf="isView('list')" (click)="setView('map')"></span>
                    <span class="ty-list" *ngIf="isView('map')" (click)="setView('list')"></span>
                </div>
            </div>
        </div>

        <div class="content_offers">

            <ng-container *ngIf="isView('list')">

                <app-core-offer-list
                        [layoutView]="view"
                        [mode]="mode"
                        [roles]="roles"
                        [publicPrice]="publicPrice"
                        [identificationNumber]="identificationNumber"
                        [filterBuilder]="filterBuilder"
                        [locale]="locale"
                        [referenced]="referenced"
                        [allowBooking]="allowBooking"
                        [allowGiftVoucher]="allowGiftVoucher"
                        [allowRequest]="allowRequest"
                        [allowOnlineSale]="allowOnlineSale"
                        [integrationMode]="integrationMode"
                        [loadItemsSourceCallback]="loadItemsSourceCallback"
                >
                </app-core-offer-list>

            </ng-container>

            <ng-container *ngIf="isView('map')">

                <app-core-offer-map
                        [layoutView]="view"
                        [mode]="mode"
                        [roles]="roles"
                        [publicPrice]="publicPrice"
                        [identificationNumber]="identificationNumber"
                        [filterBuilder]="filterBuilder"
                        [locale]="locale"
                        [referenced]="referenced"
                        [allowBooking]="allowBooking"
                        [allowGiftVoucher]="allowGiftVoucher"
                        [allowRequest]="allowRequest"
                        [allowOnlineSale]="allowOnlineSale"
                        [integrationMode]="integrationMode"
                        [loadItemsSourceCallback]="loadItemsSourceCallback"
                >
                </app-core-offer-map>

            </ng-container>
        </div>
    </div>
</div>
